import React from 'react';
import RequestQueueTabs from '../requests/RequestQueueTabs';
import OperationalRequestDetail from './OperationalRequestDetail';
import OperationalRequestTable from './OperationalRequestTable';

function OperationalRequestWorkspace({
  detailEmptyMessage,
  detailFooter = null,
  detailHistoryRefreshKey = 0,
  detailHistoryTitle,
  detailOnOpenPersonWorkspace = null,
  detailRequest,
  detailRequestTitle,
  emptyMessage,
  exportAction = null,
  filteredRequests = [],
  includeAll = false,
  introCopy,
  isInitialLoading = false,
  noResultsColSpan = 5,
  queueAllLabel = 'All Requests',
  requestFilter,
  requestSummary,
  sectionTitle,
  selectedRequestId = '',
  showRequesterColumn = false,
  skeletonColumnCount = 5,
  tableClassName = '',
  countLabel = 'shown',
  onSelectQueue,
  onSelectRequest
}) {
  return (
    <div className="role-section">
      <div className="role-section-header">
        <h2>{sectionTitle}</h2>
        <div className="role-section-actions">
          <span>{filteredRequests.length} {countLabel}</span>
          {exportAction}
        </div>
      </div>
      <p className="role-section-copy">{introCopy}</p>
      <div className="role-request-summary-row">
        <div className="role-request-summary-card" title="Awaiting a decision — no policy concerns flagged.">
          <span>Pending</span>
          <strong>{requestSummary.pending}</strong>
          <em>Awaiting decision</em>
        </div>
        <div className="role-request-summary-card role-request-summary-card-warning" title="A coverage or policy rule was triggered. These need a closer look before approving.">
          <span>Review Needed</span>
          <strong>{requestSummary.reviewNeeded}</strong>
          <em>Policy concern flagged</em>
        </div>
        <div className="role-request-summary-card">
          <span>Approved</span>
          <strong>{requestSummary.approved}</strong>
        </div>
        <div className="role-request-summary-card">
          <span>Denied</span>
          <strong>{requestSummary.denied}</strong>
        </div>
      </div>
      <RequestQueueTabs
        selectedQueue={requestFilter}
        summary={requestSummary}
        includeAll={includeAll}
        allLabel={queueAllLabel}
        onSelect={onSelectQueue}
      />
      <OperationalRequestTable
        emptyMessage={emptyMessage}
        filteredRequests={filteredRequests}
        isInitialLoading={isInitialLoading}
        noResultsColSpan={noResultsColSpan}
        selectedRequestId={selectedRequestId}
        showRequesterColumn={showRequesterColumn}
        skeletonColumnCount={skeletonColumnCount}
        tableClassName={tableClassName}
        onSelectRequest={onSelectRequest}
      />
      <OperationalRequestDetail
        request={detailRequest}
        requestTitle={detailRequestTitle}
        emptyMessage={detailEmptyMessage}
        footer={detailFooter}
        historyRefreshKey={detailHistoryRefreshKey}
        historyTitle={detailHistoryTitle}
        onOpenPersonWorkspace={detailOnOpenPersonWorkspace}
      />
    </div>
  );
}

export default OperationalRequestWorkspace;
